import React, { createContext, useContext, useState } from 'react'

interface FiltersClient {
  reason: string
  nm_client: string
}

interface FilterClientsType {
  filters: FiltersClient
  setFilters: React.Dispatch<React.SetStateAction<FiltersClient>>
}

const FilterContextClient = createContext<FilterClientsType | undefined>(undefined)

export const FilterProviderClient: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [filters, setFilters] = useState<FiltersClient>({
    reason: '',
    nm_client: '',
  })

  return (
    <FilterContextClient.Provider value={{ filters, setFilters }}>
      {children}
    </FilterContextClient.Provider>
  )
}

export const useFilterClient = (): FilterClientsType => {
  const context = useContext(FilterContextClient)
  if (!context) {
    throw new Error('useFilter must be used within a FilterProviderClient')
  }
  return context
}
